/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react library for routing
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import {getMenu} from "services/MenuService";
import { initTableScrollObserver } from "utils/tableScrollEnhancer";

function Admin() {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  const [menuBase, setMenuBase] = React.useState(null);
  const [menuVisible, setMenuVisible] = React.useState(null);

  const resetScroll = React.useCallback(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, []);

  const obtenerMenu = React.useCallback(async() => {
    let mu = await getMenu();
    if (mu) {
      setMenuBase(mu);
      setMenuVisible(mu);
    }
  }, []);

  const restaurarMenu = React.useCallback(() => {
    if (menuBase) {
      setMenuVisible(menuBase);
    }
  }, [menuBase]);

  React.useEffect(() => {
    document.body.classList.add("g-sidenav-pinned");
    document.body.classList.remove("g-sidenav-hidden");
    obtenerMenu();
    return initTableScrollObserver();
  }, [obtenerMenu]);

  React.useEffect(() => {
    resetScroll();
  }, [location.pathname, resetScroll]);

  React.useEffect(() => {
    if (location.pathname === "/admin/home") {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
      setSidenavOpen(false);
    }
  }, [location.pathname]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  const toggleSidenav = (e) => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };
  const getNavbarTheme = () => {
    return location.pathname.indexOf("admin/alternative-dashboard") === -1
      ? "dark"
      : "light";
  };

  return (
    <>
      {menuVisible?
      <>
        <Sidebar
          routes={menuVisible}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          obtenerMenu={restaurarMenu}
          setMenu={setMenuVisible}
          Menu={menuBase}
          logo={{
            innerLink: "/admin/home",
            imgSrc: require("assets/img/logo-Global-Net4.png").default,
            imgAlt: "...",
          }}
        />
        <div className="main-content" ref={mainContentRef}>
          <AdminNavbar
            theme={getNavbarTheme()}
            toggleSidenav={toggleSidenav}
            sidenavOpen={sidenavOpen}
            brandText={getBrandText(location.pathname)}
          />
          <Switch>
            {getRoutes(routes)}
            <Redirect from="*" to="/admin/dashboard" />
          </Switch>
          
        </div>
        {sidenavOpen ? (
          <div className="backdrop d-xl-none" style={{ pointerEvents: "none" }} />
        ) : null}
      </>
      :
      <></>
      }
    </>
  );
}

export default Admin;
